import { useState } from "react";
import Button from "@/components/Core/Button/Button";
import Dropdown from "@/components/Core/Dropdown/Dropdown";
import Contract from "@/models/Contract";
import { CONTRACT_SORTING_COLUMN } from "@/models/Sorting";
import { useContracts } from "@/networking/contract.hooks";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";

const StandardavtalPage = () => {
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation } = useUpdateOrganisation();
	const [defaultContractId, setDefaultContractId] = useState(organisation?.defaultContractId || "");

	const { contracts = [] } = useContracts({
		page: 1,
		pageSize: 1000,
		sort: CONTRACT_SORTING_COLUMN.NAME,
		isDeleted: false,
		active: true,
	});

	function save() {
		updateOrganisation({ defaultContractId });
	}

	return (
		<SettingsLeaf
			title="Standardavtal"
			description="Avtal som används för kunder om inget annat avtal är satt."
		>
			<Dropdown<Contract>
				placeholder="SELECT_CONTRACT"
				name="contract"
				getOptionLabel={(option) => option.name}
				options={contracts}
				value={defaultContractId}
				getValue={(c) => c.id}
				onChange={setDefaultContractId}
			/>
			<div>
				<Button onClick={save}>Uppdatera standardavtal</Button>
			</div>
		</SettingsLeaf>
	);
};

export default StandardavtalPage;
